import externalCommandHandler from '../externalCommandHandlers/externalCommandHandler';

export default externalCommandHandler;
